import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/ocpp")({
  component: OcppSectionLayout,
});

function OcppSectionLayout() {
  return <Outlet />;
}
